import React from 'react';
import { SurveyProvider, useSurvey } from './Context';

import Loader from '../components/Loader';
import AppSidebar from '../components/AppSidebar';
import AppMain from '../components/AppMain';
import AppHeader from './AppHeader';
import AppFilters from './AppFilters';
import AppQuestions from './AppQuestions';
import AppDisplay from './AppDisplay';

function AppContent() {
    const { isInitialLoading } = useSurvey();

    if (isInitialLoading) {
        return <Loader />;
    }

    return (
        <div className="app-wrapper container">
            <AppSidebar>
                <AppFilters />
                <AppQuestions />
            </AppSidebar>
            <AppMain>
                <AppHeader />
                <AppDisplay />
            </AppMain>
        </div>
    );
}

function App() {
    return (
        <SurveyProvider>
            <AppContent />
        </SurveyProvider>
    );
}

export default App;
